















import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconRemoveReferral extends Vue {
    @Prop({ type: Number, default: 22 }) readonly size!: number
}
